function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #blog-bg .cls-1 {\r\n        fill: #f2f2f2;\r\n      }\r\n\r\n      #blog-bg .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "blog-bg",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "seccao_8_fundo"
}, /*#__PURE__*/React.createElement("path", {
  id: "_2_elemento",
  "data-name": "2_elemento",
  className: "cls-1 rotate-center",
  d: "M445,1409.79a417.6,417.6,0,0,0,68.6-4.22l-.25.13s383.93-41.34,698-348.16l-.24.12c90.07-80.86,148.21-199.85,151-333.6s-50.12-254.9-136.56-339.49C925.67,65.67,545.21,7.5,543,7.17A415.64,415.64,0,0,0,474.84.09C285.3-3.92,121.58,120.26,59.55,296.56c0,0-109.15,279.39-31.9,733.5v0C59.72,1241.66,232.79,1405.29,445,1409.79Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_1_elemento_branco",
  "data-name": "1_elemento_branco",
  className: "cls-2",
  d: "M641,1356.86a364.55,364.55,0,0,0,57.28-19.19l-.18.17s316.49-122.47,513.31-454.41l-.18.15c58.06-89.15,80.33-203.38,52.3-317.57S1163,361,1070.35,308.91C743.15,106.47,407,143.69,405,143.91a364.43,364.43,0,0,0-59.45,9.5C183.72,193.14,73,335.82,60.47,499.59c0,0-29.06,262,139.87,629.91h0C275.72,1301.83,459.88,1401.34,641,1356.86Z"
})));

function SvgFundo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1362.29 1409.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundo);
export default __webpack_public_path__ + "static/media/fundo.fc981846.svg";
export { ForwardRef as ReactComponent };